import { SDKConfig } from "@sdk/default-sdk-config";
import { getHqToken } from "@/hq/hq-auth";
import { HqService } from "./hq.service";

export const HqSDK = new HqService({
  ...SDKConfig,
  token: getHqToken() ?? "",
});
